<template>
  <mini-button-full class="button-cart"
                    :class="{ 'isQtyExist': !qtyInCart }"
                    data-testid="addToCart"
                    :disabled="isProductDisabled"
                    @click.native="addToCart(product)"
  >
    <img src="/assets/shop/cart.png" class="button-cart-image" alt="cart" v-if="!qtyInCart" width="64" height="64" loading="lazy" fetchpriority="auto">
    <span class="button-cart-qty" v-else> {{ qtyInCart }} </span>
  </mini-button-full>
</template>

<script>
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import { AddToCart } from '@vue-storefront/core/modules/cart/components/AddToCart'
import focusClean from 'theme/components/theme/directives/focusClean'
import Vue from 'vue';

const MiniButtonFull = () => import(/* webpackChunkName: "vsf-mini-button-full" */ 'theme/components/theme/MiniButtonFull.vue');

export default {
  name: 'MiniAddToCart',
  mixins: [AddToCart],
  directives: { focusClean },
  components: { MiniButtonFull },
  methods: {
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    }
  },
  computed: {
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    },
    cartItem () {
      let item = null
      this.$store.getters['cart/groupedCart'].forEach(gr => {
        if (gr.partner.code === this.product.partner_code) {
          item = gr.items.find(it => it.sku === this.product.sku)
        }
      })
      return item
    },
    qtyInCart () {
      let items = []
      try {
        items = JSON.parse(Vue.$cookies.get('cart'))
      } catch (e) {
        console.error(e)
      }
      if (this.cartItem) {
        return this.cartItem.stock.is_qty_decimal ? parseFloat(this.cartItem.qty.toFixed(2)) : this.cartItem.qty
      }
      if (items) {
        let item = items.find(p => this.product.sku === p.sku)
        return item ? item.qty : false
      }
      return false
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  }
}
</script>

<style lang="scss" scoped>
  .button-cart {
    width: 32px;
    height: 32px;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #11bb2e;
    border: none;
    border-radius: 50%;
    outline: none;

    transition: .2s;

    &:hover {
      cursor: pointer;
      opacity: .7;
    }

    &-image {
      width: 16px;
      height: 16px;
    }

    &-qty {
      color: #fff;
      font-size: 12px;
    }
  }
</style>
